<template>
  <div class="step-block">
    <div class="item-head">
      <span class="type-chip">مرحله</span>
      <span class="id-chip">{{ item.id }}</span>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان مرحله">
      <input type="text" class="form-control event" :id="`item-3-${item.id}`" v-model="item.config.event_name" placeholder="رویداد">
    </div>
    <div class="item-meta">
      <label class="mini-check">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        محافظت
      </label>
      <label class="mini-check">
        <input :id="`item-1-${item.id}`" type="checkbox" v-model="item.config.send_sms_after_answer">
        پیامک
      </label>
      <label class="mini-check">
        <input :id="`item-2-${item.id}`" type="checkbox" v-model="item.config.admin_approval">
        تایید ادمین
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepInput",
  props: {item: {}},
  created() {
    if (!this.item.config) {
      this.$set(this.item, 'config', {})
    }
  }
}
</script>

<style scoped>
.item-head,
.item-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.item-meta {
  margin-top: 8px;
}
.type-chip,
.id-chip {
  font-size: 11px;
  color: #6f675f;
  background: #f3f0ec;
  border-radius: 999px;
  padding: 3px 8px;
}
.id-chip {
  background: transparent;
  color: #b3aba3;
  border: 1px solid #eee9e4;
}
.title-input {
  width: 200px;
  max-width: 100%;
  flex: 0 0 200px;
}
.event {
  width: 140px;
  flex: 0 0 140px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
}
</style>
